import '@/prototypes/index.js';

export default function CustomInputRules(formulateInstance) {
  formulateInstance.extend({
    rules: {
      minimum: ({ getFormValues }, min, field) => {
        const value = getFormValues()[field]?.clearCurrencyChars();

        return parseInt(value) >= parseInt(min);
      },
      maximum: ({ getFormValues }, max, field) => {
        const value = getFormValues()[field]?.clearCurrencyChars();

        return parseInt(value) <= parseInt(max);
      },
      validDNI: ({ getFormValues }) => {
        const regex = new RegExp(/^(\d{8})[TRWAGMYFPDXBNJZSQVHLCKE]$/i);
        const dni = getFormValues()['dni'];

        return regex.test(dni);
      },
      validNIE: ({ getFormValues }) => {
        const regex = new RegExp(/^[XYZxyz](\d{7})[TRWAGMYFPDXBNJZSQVHLCKE]$/i);
        const nie = getFormValues()['nie'];

        return regex.test(nie);
      },
      validDNINIE: ({ getFormValues }) => {
        const regexDni = new RegExp(/^(\d{8})[TRWAGMYFPDXBNJZSQVHLCKE]$/i);
        const regexNie = new RegExp(/^[XYZxyz](\d{7})[TRWAGMYFPDXBNJZSQVHLCKE]$/i);
        const dniNie = getFormValues()['dni'];
        const isDni = regexDni.test(dniNie);

        if (!isDni) {
          return regexNie.test(dniNie);
        }

        return isDni;
      },
      validSupportNumber: ({ getFormValues }) => {
        const regex = new RegExp(/^[CEce](\d{8})$/i);
        const supportNumber = getFormValues()['nieSupportNumber'] || '';

        return regex.test(supportNumber);
      }
    },
  });
}
